import script from "./GameView.vue?vue&type=script&setup=true&lang=js"
export * from "./GameView.vue?vue&type=script&setup=true&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=49aea662&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49aea662"]])

export default __exports__